import React, { FunctionComponent, useEffect, useState } from 'react';
import { useReactiveVar } from '@apollo/client';
import SummaryPrices from './SummaryPrices';
import { selectedCurrencyVar } from '../../../../../../../gqlCommon/graphql/cache';
import useTotalFeatures from '../../../../../../hooks/prices/useTotalFeatures';
import useCarPrices from '../../../../../../hooks/prices/useCarPrices';
import usePlatformConfig from '../../../../../../../common/react/usePlatformConfig';
import useCustomizeCarContext from '../../../../../../hooks/useCustomizeCarContext';

const SummaryPricesContainer: FunctionComponent = () => {
  const [trimName, setTrimName] = useState('');
  const { selectedCar, loading } = useCustomizeCarContext();
  const selectCarPrices = selectedCar?.prices;
  const { totalFeaturesPrices } = useTotalFeatures(selectCarPrices.totalFeatures);
  const { discounts } = useCarPrices(selectCarPrices);
  const selectedCurrency = useReactiveVar(selectedCurrencyVar);
  const basketDiscounts = selectedCar.prices.discounts;
  const carData = selectedCar?.car;
  const carName = carData?.attributes?.vehicleDisplayName ?? '';
  const taxLabel = carData?.attributes?.priceLabel ?? '';
  const hasDiscounts = discounts.length > 0;

  const {
    platformConfig: { isComplexModel },
  } = usePlatformConfig();

  useEffect(() => {
    if (!loading && carData) {
      const currentTrimLabel = carData.trim.attributes.label;
      const currentVariantName = selectedCar?.car?.variant?.attributes.name ?? '';
      setTrimName(`${currentTrimLabel} ${currentVariantName}`);
    }
  }, [carData]);

  return (
    <SummaryPrices
      title={isComplexModel ? carName : trimName}
      loading={loading}
      currency={selectedCurrency}
      discounts={hasDiscounts ? discounts : null}
      basketDiscounts={basketDiscounts.length > 0 ? basketDiscounts : null}
      originalPrice={selectCarPrices.carPrice.originalPrice}
      totalPrices={selectCarPrices.totalPrice}
      totalFeatures={totalFeaturesPrices}
      totalOfferFeatures={selectCarPrices.totalOfferFeatures}
      taxLabel={taxLabel}
      additionalGovernmentTaxes={selectedCar.additionalGovernmentTaxes}
      oneForOneReplacement={selectedCar?.finance?.simulation?.oneForOne}
    />
  );
};

export default SummaryPricesContainer;
